import script from "./NavTop.vue?vue&type=script&setup=true&lang=js"
export * from "./NavTop.vue?vue&type=script&setup=true&lang=js"

import "./NavTop.vue?vue&type=style&index=0&id=9487fd9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9487fd9a"]])

export default __exports__